<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
    <div class="placeholder-bottom"></div>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    this.prevent
  },
  methods: {
    
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.placeholder-bottom{
  width: 100%;
  height: 140px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue